var exports = {
  "O": "x61f99309--4a6698--subtitle__icon",
};

module.exports = exports;
